import { createContext, Dispatch, SetStateAction } from 'react';

// Definindo a interface do dado armazenado na lista
interface EntradaDado {
  nomeEmpresa: string;
  saldo: string;
  dataAtiva: string;
}

// Definindo a interface para o contexto que será usado
interface ListaDadoContextType {
  listInfoLateralEntradasDados: EntradaDado[];
  setListInfoLateralEntradasDados: Dispatch<SetStateAction<EntradaDado[]>>;
}

// Criando o contexto com um valor inicial adequado
const listaDeInputs = createContext<ListaDadoContextType>({
  listInfoLateralEntradasDados: [], // Iniciando como uma lista vazia
  setListInfoLateralEntradasDados: () => {}, // Função vazia como padrão
});

// Definindo a interface para o contexto AdicionandoDados
interface AdicionandoDadosContextType {
  estaAdicionandoDados: boolean;
  setEstaAdicionandoDados: Dispatch<SetStateAction<boolean>>;
}

// Criando o contexto com um valor inicial
const AdicionandoDados = createContext<AdicionandoDadosContextType>({
  estaAdicionandoDados: false,
  setEstaAdicionandoDados: () => {}, // Função vazia como padrão
});

// Exportando como named exports
export { AdicionandoDados, listaDeInputs };
